export const ALLOWED_PROP_TYPES = [
  'TEXT',
  'METER',
  'HIDDEN',
  'PERCENT',
  'PERCENT_DECIMAL',
  'DOLLARS',
  'NUMBER',
  'PERCENT_DECIMAL',
  'SMALL_NUMBER',
  'TEXT_MAP',
  'DATE',
  'LINK',
  'IMAGE',
  'TEXT_TABLE',
];
